import { WsError } from '@amzn/work-spaces-web-client-core-lib';
import { I18nError } from '@/lib/I18nError';
import ErrorDetails from '@/views/Error/components/ErrorDetails';

/**
 * Fallback UI rendered by the top-level {@link ErrorBoundary} after an
 * unhandled error. Reuses the standard {@link ErrorDetails} presentation with a
 * generic unknown-error message so the experience is consistent with the rest
 * of the client. Recovery performs a full reload to the registration page,
 * which guarantees a clean application state after an unexpected crash (a
 * client-side navigation would keep the already-errored React tree mounted).
 */
const GlobalErrorFallback: React.FC = () => {
  const error = I18nError.getI18nError(WsError.getUnknownError());

  const restart = () => {
    window.location.assign('/registration');
  };

  return (
    <ErrorDetails
      error={error}
      onClose={restart}
      showLoginPageRedirect={false}
      goToLoginPage={restart}
    />
  );
};

export default GlobalErrorFallback;
